// SUBMIT DISABLE : this function affects views/sequences/new.html.erb by
// diabling the sequencetext form submit button
$(document).ready( function() {
  $('.sequenceform form').submit(function() {
    $(":submit",this).attr("disabled", "disabled");
  })
});
